<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Cuánto producto hace falta por material y punto. 
                Suma lo que se pidió y lo que falta por entregar 
                para estimar reabastecimiento. Úsalo para planear 
                compras o traslados y evitar quiebres.
              </p>
            </div>
          </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
                Necesidad Total
            </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza por <b>material</b> la cantidad solicitada, basada en la necesidad de los <b>socios de negocio</b>.
        </div>
      </div>
      <!-- Header -->
      <div
          class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex shrink-0">
              <!-- Title -->
              <!--<div class="text-3xl font-extrabold tracking-tight">Pedidos</div> -->
          </div>
          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
              <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                  <span class="ml-2">Exportar</span>
              </button>
          </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
    @if (!isChart) {
                
        <div class="flex flex-auto overflow-hidden flex-row gap-4 p-4">
            <!-- Cambiado a flex-row y añadido gap para separación -->
            <!-- Columna de la tabla (ancho 60%) -->
            <div class="w-3/5 flex flex-col flex-1 min-h-0" style="height: calc(100vh - 270px)">
                <div class="overflow-auto flex-1">
                    <app-smart-grid
                        [data]="data"
                        [columnDefs]="columnDefs"
                        [config]="gridConfig"
                        [loading]="loading"
                        [totalRecords]="totalItems"
                        (pageChanged)="onPageChanged($event)"
                        (sortChanged)="onSortChanged($event)">
                    </app-smart-grid>
                </div>
            </div>

            <div class="w-2/5 flex flex-col">
                <div class="bg-gray-50 dark:bg-gray-800 rounded-lg shadow p-4 h-full flex flex-col">
                    <!-- Encabezado con controles -->
                    <div class="flex justify-between items-center mb-4">
                        <h3 class="text-lg font-semibold text-gray-800 dark:text-white"></h3>
                        <div class="flex space-x-2 items-center">
                            <mat-form-field appearance="outline" class="w-64 text-lg">
                                <mat-label>Tipos</mat-label>
                                <mat-select [(value)]="selectedChart" (selectionChange)="changeChart()">
                                    <mat-option value="top-clients">Clientes con más compras</mat-option>
                                    <mat-option value="products-sold">Productos más Vendidos</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- <button mat-button (click)="exportChart()" class="flex items-center h-[56px]"  matTooltip="Descargar Reporte"> -->
                                <mat-icon color="primary" svgIcon="excel" (click)="exportChart()" matTooltip="Descargar Reporte"
                                    class="pointer-icon flex items-center h-[56px]"></mat-icon>
                                <!-- <span class="ml-1"></span> -->
                            <!-- </button> -->
                        </div>
                    </div>
            
                    <div class="flex-grow">
                        <div id="chart-d" class="w-full h-full min-h-[400px]"></div>
                    </div>
            
                    <div class="text-xs text-gray-500 dark:text-gray-400 mt-2">
                        <span *ngIf="selectedChart === 'top-clients'">Mostrando los 10 clientes con mayor volumen de compras</span>
                        <span *ngIf="selectedChart === 'products-sold'">Productos más vendidos por cantidad</span>
                    </div>
                </div>
            </div>

        </div>
    } @else {
        <div class="flex flex-col flex-1 min-h-0" style="height: calc(100vh - 270px)">
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <app-smart-grid
                [data]="data"
                [columnDefs]="columnDefs"
                [config]="gridConfig"
                [loading]="loading"
                [totalRecords]="totalItems"
                (pageChanged)="onPageChanged($event)"
                (sortChanged)="onSortChanged($event)">
            </app-smart-grid>
          </div>
        </div>
    }
    </div>
  </div>

    <!-- Filtros -->
<app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">

    <app-filter-section title="Rango de fechas" [expanded]="true">
        <app-dates-filters [form]="form" [showDateCreationRange]="true"
         [showUploadDateRange]="true" [showDeliveryDate]="true"></app-dates-filters>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
        <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
            [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
        <app-documents-filters [form]="form" [documentClass]="true" [typeDocumentClass]="type"
        [loadData]="loadDocumentsData"></app-documents-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
        <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
        <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
            [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
        <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
        [loadData]="loadMaterialsData">
        </app-materials-management-filters>
    </app-filter-section>
</app-filter>
</mat-sidenav-container>